export const API_URL = "https://verify.dev.dexcart.in/api/";